import {GridActions, GridState} from './types';

export const gridStateSet = (gridId: string, state: Partial<GridState<any>>) => ({
  type: GridActions.SET_STATE,
  gridId,
  state,
});
